import CloseIcon from '@mui/icons-material/Close';
import { Theme, SxProps } from '@mui/material';
import { IconButton, IconButtonProps } from 'shared/mui/IconButtons';
import { Tooltip } from 'shared/mui/Tooltip';

type Props = {
  tooltipText?: string;
} & IconButtonProps;

export const GatewayRulesFormRemoveButton: React.FC<Props> = ({
  sx,
  color = 'error',
  tooltipText,
  ...restProps
}) => {
  const defaultSx: SxProps<Theme> = {
    width: '32px',
    height: '32px',
  };

  return (
    <IconButton color={color} sx={{ ...defaultSx, ...sx }} {...restProps}>
      <Tooltip arrow placement="top" title={tooltipText}>
        <CloseIcon
          sx={{
            fontSize: '24px',
          }}
        />
      </Tooltip>
    </IconButton>
  );
};
